import { render } from "./Socials.vue?vue&type=template&id=8f699f64&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=ts"
export * from "./Socials.vue?vue&type=script&lang=ts"

import "./Socials.vue?vue&type=style&index=0&id=8f699f64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8f699f64"

export default script